var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":"transparent"}},[(_vm.content)?[(_vm.title && _vm.content.title)?_c('h2',{staticClass:"mb-5"},[_vm._v(_vm._s(_vm.content.title))]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }